export const text = {
  title: "Saved Cards",
  cardNumberPlaceHolder: "Enter card number",
  cardNamePlaceHolder: "Cardholder Name",
  expiryDatePlaceHolder: "Expiry Date (MM/YY)",
  cardNumber: "Card Number",
  cardName: "Enter Name on Card",
  expiryDate: "Expiration Date",
  cvv: "CVV",
};
